import { LoggerService } from "rainbow-web-sdk/services/core/logger.service";
import { stringifyError } from "./stringifyError";

export class PromiseQueue {
    private queue: (() => Promise<any>)[] = [];
    private started: boolean = false;
    private logger: LoggerService = LoggerService.getInstance();

    public static create() { return new PromiseQueue(); }

    public add(promise: () => Promise<any>) {
        this.queue.push(promise);
        if (!this.started) { this.started = true; this.execute(); }
    }

    private execute() {
        const promise = this.queue.shift();
        if (promise) {
            try {
                this.timeoutPromise(20000, promise) // the promise will time out after 20 sec
                    .then(() => { this.execute(); })
                    .catch((error: unknown) => {
                        const errorMessage = error !== undefined ? stringifyError(error) : "unknownError";
                        // No need to dump stack : it is already dumped by promise s own error handling
                        this.logger.error(`[PromiseQueue] execute failure -- ${errorMessage}`);
                        this.execute();
                    });
            } catch (error) {
                const errorMessage = error !== undefined ? stringifyError(error) : "unknownError";
                const errorStack = error instanceof Error ? error.stack : "Unknown stack";
                this.logger.error(`[PromiseQueue] execution exception  -- ${errorMessage} : ${errorStack}`);
                this.execute();
            }
        } else { this.started = false; }
    }

    private timeoutPromise<T>(ms: number, promise: () => Promise<T>): Promise<T> {
        let timeoutId: ReturnType<typeof setTimeout> | undefined = undefined;
        // Create a promise that rejects in <ms> milliseconds
        const timeout = new Promise<T>((__resolve, reject) => {
            timeoutId = setTimeout(() => { reject(new Error(`Timed out in ${ms.toString()}ms.`)); }, ms);
        });

        // Returns a race between our timeout and the passed in promise
        return Promise.race([promise(), timeout]).then((value) => { clearTimeout(timeoutId); return value; });
    }
}
